// JsFromRoutes CacheKey 1c1c2362ff51834607ccb2a41b40a6be
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/contact_categories'),
}
